<div class="mx-4 mat-typography">
  <div class="d-flex flex-row-reverse mx-2 mt-4">
    <button mat-flat-button color="primary" (click)="openNewTemplateDialog()">
      <mat-icon class="mr-1">add</mat-icon>{{'reporttemplateComponent.newTemplate' | translate}}
    </button>
    <button *ngIf="isVisol" mat-flat-button color="primary" class="mr-2" (click)="importbutton.click();">
      <mat-icon class="mr-1">unarchive</mat-icon>{{'reporttemplateComponent.import' | translate}}
    </button>
    <input hidden #importbutton type="file" accept=".zip"
            (change)="importReportTemplate($event.target.files, null); importbutton.value=''" />
    
    <button *ngIf="!isVisol" mat-flat-button color="primary" class="mr-2" (click)='openImageUploadDialog()'>
      <mat-icon class="mr-1">add</mat-icon>{{'reporttemplateComponent.images' | translate}}
    </button>

    <button *ngIf="!isVisol" mat-flat-button color="primary" class="mr-2" (click)="importTemplate.click();">
      <mat-icon class="mr-1">unarchive</mat-icon>{{'reporttemplateComponent.importTemplate' | translate}}
    </button>
    <input hidden #importTemplate type="file" accept=".zip"
            (change)="importReportTemplateAsync($event.target.files); importTemplate.value=''" />


  </div>

  <div *ngIf="reportTemplatesListDataSource.data && reportTemplatesListDataSource.data.length > 0" class="d-flex my-2">
    <mat-table #modeltable [dataSource]="reportTemplatesListDataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.templateName' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.name }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="application">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.product' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ 'objects.' +row.application | translate }} </mat-cell>
      </ng-container>
      <ng-container *ngIf="!isVisol" matColumnDef="reportType">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.type' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ 'objects.' +row.reportType | translate }}</mat-cell>
      </ng-container>
      <ng-container *ngIf="!isVisol" matColumnDef="equipmentType">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.equipmentTypes' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="eq-container" [matTooltip]="getEquipmentTypesString(row.equipmentType)" matTooltipPosition="above" matTooltipClass="osc-tooltip">
            <div [matBadge]=" '+' + (row.equipmentType?.split(',').length-1)" [matBadgeHidden]="row.equipmentType?.split(',').length<2">
              <span class="equipment-type">{{ row.equipmentType ? getEquipmentType(row.equipmentType): '' }}</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedDateUtc">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.lastupdatedDate' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ convertUTCTimeToLocal(row.lastUpdatedDateUtc) | customDate: 'medium' }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedBy">
        <mat-header-cell *matHeaderCellDef>{{'reporttemplateComponent.lastupdatedBy' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.lastUpdatedByName === 'Unknown User' ? ('reporttemplateComponent.unknownUser' | translate) : row.lastUpdatedByName }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row" class="icon-container">
          <mat-icon *ngIf="isVisol" class="mr-1 float-right olympus-icon" (click)="importbutton.click();$event.stopPropagation()" [matTooltip]="'reporttemplateComponent.import' | translate">unarchive</mat-icon>
          <mat-icon class="mr-1 float-right olympus-icon" (click)="exportReportTemplate(row);$event.stopPropagation()" [matTooltip]="'reporttemplateComponent.export' | translate">archive</mat-icon>
          <mat-icon class="mr-1 float-right olympus-icon" (click)="cloneTemplate(row, $event)" [matTooltip]="'reporttemplateComponent.clone' | translate">
            file_copy
          </mat-icon>
          <mat-icon class="mr-1 float-right text-danger" (click)="deleteTemplate(row, $event)">delete</mat-icon>
          <mat-icon *ngIf="!isVisol" class="mr-1 float-right" (click)="editTemplate(row, $event)" [matTooltip]="'reporttemplateComponent.edit' | translate">edit</mat-icon>
          <input hidden #importbutton type="file" accept=".zip" (click)="$event.stopPropagation()"
                 (change)="importReportTemplate($event.target.files, row); importbutton.value=''" />
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <!--<mat-row [ngClass]="{ 'editable': isTemplateEditable }" *matRowDef="let row; columns: displayedColumns;"
   (click)="editReportTemplate(row)"></mat-row>-->
      <mat-row [ngClass]="{ 'editable': isTemplateEditable, 'disabled': isTemplateEditable && !row.isValid && isVisol }" *matRowDef="let row; columns: displayedColumns;"
               (click)="editReportTemplate(row)"></mat-row>
    </mat-table>
  </div>
  <div *ngIf="!isLoading && reportTemplatesListDataSource.data.length === 0" class="no-data-txt">
    {{'reporttemplateComponent.notemplates' | translate}}
  </div>
</div>
